/** Build-time flag — Master has no runtime-config pipeline. */
export function isWfxAuthEnabled(): boolean {
  return WFX_AUTH_ENABLED === 'true';
}
